module.exports = __webpack_public_path__ + "img/spaceship-03.10da9a90.png";